const url = '/meals';
const Provider = 'meals';
const dbModel = 'meals';

export { url, Provider, dbModel };
